import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import { connect } from 'react-redux';
import WithRouter from 'custom/withRouter';

/**
 * 
 * @param {array} links - Arrays with link and text
 * @param {function} redirectTo - Function to redirect to previous page
 * @param {string} current - Text representation of current page 
 */
class Breadcrumb extends Component {
  redirectTo = (r) => {
    this.props.navigate(r)
  }
  render() {
    const { links, redirectTo, current } = this.props;

    return (
      <section className="PageHeaderLinks">
        <ol className="breadcrumb">
          {links.map((l, index) => (
            <li key={index}>
              <Link to={l.link}> {l.text} </Link>
            </li>
          ))}
          <li className="active">{current}</li>
        </ol>
        {redirectTo && <Button type="HeaderBackPage" onTouchTap={() => this.redirectTo(redirectTo)} />}
      </section>
    );
  }
}

function mapStatetoProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(Breadcrumb));